// React
import React from 'react'
// Components
import Icon from '../Display/Icon'

export default class Compatibility extends React.Component {

	componentDidMount() {
		document.addEventListener('keydown', this.escFunction, false)
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.escFunction, false)
	}

	escFunction = (event) => {
		if(event.keyCode === 27) {
			this.removePage()
		}
	}

	removePage = () => {
		window.localStorage.removeItem('MoonSignApp:compatibility')
		if (this.props.state.nav.length > 1) {
			this.props.redux.nav.removePage()
		}
		else {
			this.props.redux.nav.setPage('relationships')
		}
	}

	render() {
		return (
			<div className='capps-fullscreen'>
				<div className='capps-close' onTouchTap={() => this.removePage()}>
					<span style={{ marginRight: '5px', marginBottom: '5px' }}>close</span> <Icon name='close-circle' />
				</div>
				<div className='capps-responsive'>
					{/* INTRODUCTION */}
					<div className='capps-header'>Relationship Compatibility</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						Each person in a relationship was born under a certain moon sign &mdash; and since each sign evokes certain traits in a person, each person’s moon sign has a particular way of influencing a relationship.
						<div className='capps-height-10' />
						Each moon sign is ruled by one of four elements: <strong>fire</strong>, <strong>earth</strong>, <strong>air</strong>, and <strong>water</strong>. Each element represents certain qualities: fire signs (Aries, Leo, Sagittarius) tend to be impulsive and creative; earth signs (Taurus, Virgo, Capricorn) stable and predictable; air signs (Gemini, Libra, Aquarius) witty and curious; water signs (Cancer, Scorpio, Pisces) introspective and intuitive.
						<div className='capps-height-10' />
						In astrology, all signs are arranged in a circular fashion, like twelve pieces of a pie: Aries (fire), Taurus (earth), Gemini (air), Cancer (water), Leo (fire), Virgo (earth), Libra (air), Scorpio (water), Sagittarius (fire), Capricorn (earth), Aquarius (air), Pisces (water).
						<div className='capps-height-20' />
						<div className='capps-zodiac houses' />
						<div className='capps-height-20' />
					</div>
					<div className='capps-height-20' />
					<div className='capps-height-20' />
					<div className='capps-header'>Aspects</div>
					<div className='capps-height-10' />
					<div className='capps-form'>
						Moon signs that are the same sign (e.g. fire signs Aries and Aries) are said to be <strong>conjunct</strong> in their sign. Different moon signs that are in the same element are <strong>trine</strong> with each other (e.g. water signs Cancer and Scorpio). Signs that are separated by another sign (e.g. Libra and Sagittarius, separated by Scorpio) are said to be <strong>sextile</strong>. Signs that border the sign that is directly opposite from it are <strong>quincunx</strong> with each other (e.g. Leo to Pisces). Signs right next to each other are <strong>semi-sextile</strong> with each other (e.g. Gemini and Cancer). Opposite signs have an <strong>opposite</strong> aspect (Virgo and Pisces). And signs that have two other signs between them form a <strong>square</strong> aspect (e.g. Aquarius and Taurus).
						<div className='capps-height-10' />
						The Moon Sign App is designed to give you an introductory glance into the wonderful world of lunar astrology, and our <span onTouchTap={() => {
							window.localStorage.removeItem('MoonSignApp:compatibility')
							window.localStorage.setItem('MoonSignApp:colorScale', true)
							this.props.redux.nav.setPage('relationships')
						}} className='capps-link'>color scale</span> gives a simple indication how the moon signs of two people might interact based on the aspect that they form. However, <strong>it is by no means a comprehensive indicator of the rich and complex relationship dynamics that exist between two people and we recommend using it only as a starting point in your exploration of synastry</strong> &mdash; the study of astrological compatibility. If you wish to explore your astrological compatibility with someone else at a deeper level, we recommend you obtain an astrological reading from a trained, professional astrologer.
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Pages/Compatibility.js